import React, { Component } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../AppContext";
import { useContext } from "react";
import { useState } from "react";

const BannerV2 = () => {
  const { users } = useContext(AppContext);
  const { sendClickStatus } = useContext(AppContext);
  let publicUrl = process.env.PUBLIC_URL + "/";
  const truncate = (str, n) =>
    str && str.length > n ? str.slice(0, n) + "..." : str || "";
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  const [showVideo, setShowVideo] = useState(true);

  if (!showVideo) return null;

  return (
    <div className="post-area banner-post-area pt-2 pd-bottom-70 bg-black-mobie">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            {users.some((user) => user.post_type === "New")
              ? // If any post_type is "New", display it normally
              users
                .filter((user) => user.post_type === "New")
                .slice(0, 1)
                .map((post) => {
                  return (
                    <div
                      key={post.ID}
                      className="single-post-wrap style-overlay color-white-mobile"
                    >
                      <Link
                        to={`/news-details/${post.ID}`}
                        onClick={() => {
                          sendClickStatus(post.ID, "click");
                        }}
                      >
                        <div className="thumb">
                          <img
                            src={
                              "https://hondaapi.clientcoding.com" +
                              "/" +
                              post.guid
                            } // If using relative URL
                            // Or use: src={`https://yourdomain.com/${post.guid}`}
                            alt={post.post_title}
                            style={{ maxWidth: "100%", objectFit: "cover" }}
                            height={552}
                          />
                        </div>
                      </Link>
                      <div className="details">
                        <div className="post-meta-single mt-2 mb-0 ">
                          <p className="mb-0 color-white-mobile">
                            <i className="fa fa-clock-o" />
                            {formatDate(post.post_date_gmt)}
                          </p>
                        </div>
                        <h5 className="title color-white-mobile">
                          <Link
                            to={`/news-details/${post.ID}`}
                            onClick={() => {
                              sendClickStatus(post.ID, "click");
                            }}
                          >
                            {truncate(post.post_title, 110)}
                          </Link>
                        </h5>
                      </div>
                    </div>
                  );
                })
              : // Else, fallback to "post" with image check
              users
                .filter((user) => user.post_type === "post")
                .filter((post) =>
                  users.some(
                    (img) =>
                      img.post_type === "attachment" &&
                      img.post_parent === post.ID
                  )
                )
                .slice(1, 3)
                .map((post) => {
                  const image = users.find(
                    (img) =>
                      img.post_type === "attachment" &&
                      img.post_parent === post.ID
                  );

                  return (
                    <div
                      key={post.ID}
                      className="single-post-wrap style-overlay"
                    >
                      {" "}
                      <Link
                        to={`/news-details/${post.ID}`}
                        onClick={() => {
                          sendClickStatus(post.ID, "click");
                        }}
                      >
                        <div className="thumb">
                          <img
                            src={image.guid}
                            alt={post.post_title}
                            style={{ maxWidth: "100%", objectFit: "cover" }}
                            height={552}
                          />
                        </div>
                      </Link>
                      <div className="details">
                        <div className="post-meta-single mt-2">
                          <p className="mb-0 color-white-mobile">
                            <i className="fa fa-clock-o" />
                            {formatDate(post.post_date_gmt)}
                          </p>
                        </div>
                        <h5 className="title color-white-mobile">
                          <Link
                            to={`/news-details/${post.ID}`}
                            onClick={() => {
                              sendClickStatus(post.ID, "click");
                            }}
                          >
                            {truncate(post.post_title, 70)}
                          </Link>
                        </h5>
                      </div>
                    </div>
                  );
                })}

            <div className="row">
              {users.some((user) => user.post_type === "New")
                ? // If "New" posts exist, display 2 of them
                users
                  .filter((user) => user.post_type === "New")
                  .slice(1, 3) // show first 2 "New" posts
                  .map((post) => {
                    return (
                      <div key={post.ID} className="col-lg-6 col-sm-6">
                        <div className="single-post-wrap style-overlay">
                          <Link
                            to={`/news-details/${post.ID}`}
                            onClick={() => {
                              sendClickStatus(post.ID, "click");
                            }}
                          >
                            <div className="thumb">
                              <img
                                src={
                                  "https://hondaapi.clientcoding.com" +
                                  "/" +
                                  post.guid
                                } // adjust if needed
                                alt={post.post_title}
                                height={250}
                                style={{
                                  maxWidth: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </Link>
                          <div className="details">
                            <div className="post-meta-single mt-2">
                              <p className="mb-0 color-white-mobile">
                                <i className="fa fa-clock-o" />
                                {formatDate(post.post_date_gmt)}
                              </p>
                            </div>
                            <h6 className="title color-white-mobile">
                              <Link
                                to={`/news-details/${post.ID}`}
                                onClick={() => {
                                  sendClickStatus(post.ID, "click");
                                }}
                              >
                                {truncate(post.post_title, 70)}
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : // Else fallback to "post" with image check
                users
                  .filter((user) => user.post_type === "post")
                  .filter((post) =>
                    users.some(
                      (img) =>
                        img.post_type === "attachment" &&
                        img.post_parent === post.ID
                    )
                  )
                  .slice(1, 3) // show posts after first one
                  .map((post) => {
                    const image = users.find(
                      (img) =>
                        img.post_type === "attachment" &&
                        img.post_parent === post.ID
                    );

                    return (
                      <div key={post.ID} className="col-lg-6 col-sm-6">
                        <div className="single-post-wrap style-overlay">
                          <Link
                            to={`/news-details/${post.ID}`}
                            onClick={() => {
                              sendClickStatus(post.ID, "click");
                            }}
                          >
                            <div className="thumb">
                              <img
                                src={image.guid}
                                alt={post.post_title}
                                height={250}
                                style={{
                                  maxWidth: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </Link>
                          <div className="details">
                            <div className="post-meta-single mt-2   ">
                              <p className="mb-0">
                                <i className="fa fa-clock-o" />
                                {formatDate(post.post_date_gmt)}
                              </p>
                            </div>
                            <h6 className="title color-white-mobile">
                              <Link
                                to={`/news-details/${post.ID}`}
                                onClick={() => {
                                  sendClickStatus(post.ID, "click");
                                }}
                              >
                                {truncate(post.post_title, 70)}
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="section-title style-two mb-4">
              <h6 className="title">Latest News</h6>
            </div>
            {users.some((user) => user.post_type === "New")
              ? // If "New" posts exist, show first 7 (to match your 4th-10th count)
              users
                .filter((user) => user.post_type === "New")
                .slice(0, 5) // showing 7 "New" posts
                .map((post) => {
                  return (
                    <div key={post.ID} className="single-post-list-wrap">
                      <div className="media">
                        <Link
                          to={`/news-details/${post.ID}`}
                          onClick={() => {
                            sendClickStatus(post.ID, "click");
                          }}
                        >
                          <div className="media-left">
                            <img
                              src={
                                "https://hondaapi.clientcoding.com" +
                                "/" +
                                post.guid
                              } // adjust if needed
                              alt={post.post_title}
                              style={{
                                width: "100px",
                                height: "85px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </Link>
                        <div className="media-body">
                          <div className="details">
                            <div className="post-meta-single mt-2">
                              <ul>
                                <li>
                                  <i className="fa fa-clock-o" />
                                  {formatDate(post.post_date_gmt)}
                                </li>
                              </ul>
                            </div>
                            <h6 className="title">
                              <Link
                                to={`/news-details/${post.ID}`}
                                onClick={() => {
                                  sendClickStatus(post.ID, "click");
                                }}
                              >
                                {truncate(post.post_title, 50)}
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              : // Else fallback to "post" with image check
              users
                .filter((user) => user.post_type === "post")
                .filter((post) =>
                  users.some(
                    (img) =>
                      img.post_type === "attachment" &&
                      img.post_parent === post.ID
                  )
                )
                .slice(3, 10) // posts 4th to 10th
                .map((post) => {
                  const image = users.find(
                    (img) =>
                      img.post_type === "attachment" &&
                      img.post_parent === post.ID
                  );

                  return (
                    <div key={post.ID} className="single-post-list-wrap">
                      <div className="media">
                        <div className="media-left">
                          <img
                            src={image.guid}
                            alt={post.post_title}
                            style={{
                              width: "100px",
                              height: "85px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="media-body">
                          <div className="details">
                            <div className="post-meta-single mt-2">
                              <ul>
                                <li>
                                  <i className="fa fa-clock-o" />
                                  {formatDate(post.post_date_gmt)}
                                </li>
                              </ul>
                            </div>
                            <h6 className="title">
                              <Link
                                to={`/news-details/${post.ID}`}
                                onClick={() => {
                                  sendClickStatus(post.ID, "click");
                                }}
                              >
                                {truncate(post.post_title, 70)}
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>

          <div className="col-lg-3 col-sm-6 widget-category">
            <div className="section-title style-two mb-4">
              <h6 className="title">Category</h6>
            </div>
            <div className="row custom-gutters-14">
              <div className="col-sm-6">
                <div className="single-category-inner">
                  <img
                    src={publicUrl + "assets/img/news.jpg"}
                    alt="img"
                    height={75}
                  />
                  <Link className="tag-base tag-blue" to="/category/न्यूज़">
                    न्यूज़
                  </Link>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="single-category-inner">
                  <img
                    src={publicUrl + "assets/img/manoranjan.jpeg"}
                    alt="img"
                    height={75}
                  />
                  <Link className="tag-base tag-blue" to="/category/मनोरंजन">
                    मनोरंजन
                  </Link>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="single-category-inner">
                  <img
                    src={publicUrl + "assets/img/health.webp"}
                    alt="img"
                    height={75}
                  />
                  <Link className="tag-base tag-blue" to="/category/हेल्थ">
                    हेल्थ
                  </Link>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="single-category-inner">
                  <img
                    src={publicUrl + "assets/img/trending.webp"}
                    alt="img"
                    height={75}
                  />
                  <Link
                    className="tag-base tag-blue"
                    to="/category/web-stories"
                  >
                    वेब स्टोरी
                  </Link>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="single-category-inner">
                  <img
                    src={publicUrl + "assets/img/dharam.avif"}
                    alt="img"
                    height={75}
                  />
                  <Link className="tag-base tag-blue" to="/category/धर्म">
                    धर्म
                  </Link>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="single-category-inner">
                  <img
                    src={publicUrl + "assets/img/business.jpg"}
                    alt="img"
                    height={75}
                  />
                  <Link className="tag-base tag-blue" to="/category/बिजनेस">
                    बिजनेस
                  </Link>
                </div>
              </div>
              {/* <div className="col-12">
                            <div className="add">
                              <img
                                className="w-100"
                                src={publicUrl + "assets/img/add/3.png"}
                                alt="img"
                              />
                            </div>
                          </div> */}
            </div>

            <div className="">
              <h6 style={{ color: "#c7c7c7", fontSize: "14px" }}>
                Advertisement
              </h6>
              <div
                className="d-flex justify-content-center align-items-center mt-3"
                style={{
                  position: "relative",
                  background: "#e5e5e56b",
                  padding: "20px",
                }}
              >
                {/* Close Button */}
                <button
                  onClick={() => setShowVideo(false)}
                  style={{
                    position: "absolute",
                    top: "-10px",
                    right: "-10px",
                    background: "#000",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    width: "25px",
                    height: "25px",
                    fontSize: "16px",
                    lineHeight: "25px",
                    textAlign: "center",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                >
                  ✕
                </button>

                {/* Video */}
                <video
                  width="230"
                  autoPlay
                  muted
                  loop
                  controls
                  style={{ borderRadius: "10px" }}
                >
                  <source src="/logo_propdub.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerV2;
